import { get, patch } from '../util/ajax';

export const getProfile = () => {
  return get(`profile`);
};

export const patchProfile = data => {
  return patch(`profile`, data);
};
